import Layout from "modules/layout/dashboard"

import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { ReactComponent as MonitorIcon } from "assets/icons/monitor.svg"
import { ReactComponent as MemberIcon } from "assets/icons/member.svg"
import { ReactComponent as StartIcon } from "assets/icons/play.svg"
import { ReactComponent as CloseIcon } from "assets/icons/close-event.svg"

import { useTranslation } from "react-i18next"
import { Button, Flex } from "antd"
import styles from "./styles.module.scss"
import { useEventId } from "."
import { useEvent } from "./queries"
import { usePopup } from "utils/use-popup"
import StartEventModal from "./startEventModal"
import TerminateEventModal from "./terminateEventModal"

const { Main, Header } = Layout

const EventLayout: React.FC = () => {
  const { t } = useTranslation()
  const eventId = useEventId()
  const startEventModal = usePopup<string>()
  const terminateEventModal = usePopup<string>()
  const { isLoading, data } = useEvent(eventId!)
  const navigate = useNavigate()
  return (
    <Layout>
      <Header
        items={[
          {
            label: t("monitors.title"),
            key: "monitors",
            onClick: () => navigate("monitors"),
            icon: <MonitorIcon />,
          },
          {
            label: t("members.title"),
            key: "members",
            onClick: () => navigate("members"),
            icon: <MemberIcon />,
          },
        ]}
      />
      <Main>
        <Flex vertical style={{ width: "100%" }} gap="middle">
          {!isLoading && (
            <div className={styles.event_button_container}>
              {data?.status === "execution" ? (
                <Button
                  size="large"
                  type="primary"
                  loading={isLoading}
                  icon={<CloseIcon />}
                  className={styles.event_button}
                  onClick={() => terminateEventModal.open(eventId)}
                  danger
                >
                  {t("events.terminate_event")}
                </Button>
              ) : data?.status === "approved" ? (
                <Button
                  size="large"
                  type="primary"
                  loading={isLoading}
                  icon={<StartIcon />}
                  className={styles.event_button}
                  onClick={() => startEventModal.open(eventId)}
                >
                  {t("events.start_event")}
                </Button>
              ) : null}
            </div>
          )}

          <Outlet />
        </Flex>
        <StartEventModal {...startEventModal} open={startEventModal.isOpen} />
        <TerminateEventModal
          {...terminateEventModal}
          open={terminateEventModal.isOpen}
        />
      </Main>
    </Layout>
  )
}

export default EventLayout
